import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'indicator']

  static values = {
    interval: {
      type: Number,
      default: 5000
    },
    transition: {
      type: String,
      default: 'fade'
    }
  }

  connect () {
    this.index = 0
    this.show()
    this.start()
  }

  disconnect () {
    this.stop()
  }

  previous () {
    const previousIndex = this.index

    this.index =
      (this.index - 1 + this.slideTargets.length) %
      this.slideTargets.length

    this.show(previousIndex)
    this.restart()
  }

  next () {
    const previousIndex = this.index

    this.index = (this.index + 1) % this.slideTargets.length

    this.show(previousIndex)
    this.restart()
  }

  select (event) {
    const newIndex = event.params.index

    if (newIndex === this.index) return

    const previousIndex = this.index
    this.index = newIndex

    this.show(previousIndex)
    this.restart()
  }

  show (previousIndex = null) {
    if (this.transitionValue === 'slide') {
      this.showSlide(previousIndex)
    } else {
      this.showFade()
    }

    this.updateIndicators()
  }

  showFade () {
    this.slideTargets.forEach((slide, index) => {
      const active = index === this.index

      slide.classList.toggle('opacity-100', active)
      slide.classList.toggle('opacity-0', !active)
      slide.classList.toggle('z-10', active)
      slide.classList.toggle('z-0', !active)
      slide.classList.toggle('pointer-events-none', !active)

      slide.setAttribute('aria-hidden', (!active).toString())
    })
  }

  showSlide (previousIndex) {
    if (previousIndex === null) {
      this.slideTargets.forEach((slide, index) => {
        const active = index === this.index

        slide.classList.remove(
          '-translate-x-full',
          'translate-x-0',
          'translate-x-full'
        )

        slide.classList.add(
          active ? 'translate-x-0' : '-translate-x-full'
        )

        slide.classList.toggle('pointer-events-none', !active)
        slide.setAttribute('aria-hidden', (!active).toString())
      })

      return
    }

    const incoming = this.slideTargets[this.index]
    const outgoing = this.slideTargets[previousIndex]

    // Incoming starts off-screen to the left.
    incoming.classList.remove(
      '-translate-x-full',
      'translate-x-0',
      'translate-x-full'
    )
    incoming.classList.add('-translate-x-full')
    incoming.classList.remove('pointer-events-none')
    incoming.setAttribute('aria-hidden', 'false')

    incoming.getBoundingClientRect()

    // Incoming moves left -> center.
    incoming.classList.remove('-translate-x-full')
    incoming.classList.add('translate-x-0')

    // Outgoing moves center -> right.
    outgoing.classList.remove(
      '-translate-x-full',
      'translate-x-0',
      'translate-x-full'
    )
    outgoing.classList.add('translate-x-full')
    outgoing.classList.add('pointer-events-none')
    outgoing.setAttribute('aria-hidden', 'true')
  }

  updateIndicators () {
    this.indicatorTargets.forEach((indicator, index) => {
      const active = index === this.index

      indicator.classList.toggle('bg-gray-800', active)
      indicator.classList.toggle('bg-gray-300', !active)

      indicator.setAttribute('aria-current', active ? 'true' : 'false')
    })
  }

  start () {
    if (this.slideTargets.length < 2) return

    this.timer = setInterval(() => {
      const previousIndex = this.index

      this.index = (this.index + 1) % this.slideTargets.length
      this.show(previousIndex)
    }, this.intervalValue)
  }

  stop () {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
  }

  restart () {
    this.stop()
    this.start()
  }
}
